import { Expose, Type } from 'class-transformer';
import { Model } from '@shared-features/models/model';
import { shipmentReceiverFleetsList } from './shipment-receiver-fleets-list.model';

export class shipmentReceiverFleets extends Model {
  @Expose() totalReceiversCount: number;
  @Expose() totalDeclinedCount: number;
  @Expose() totalNotResponseCount: number;
  @Type(() => shipmentReceiverFleetsList)
  @Expose()
  list: shipmentReceiverFleetsList[];

  constructor() {
    super();
  }
}
